// extracted by mini-css-extract-plugin
export default {"ready":"Share_ready__ASNDV"};